
import { getSocialFeedTotalPages } from '@/utils/socialFeed';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'social-feed-pagination' })
export default class SocialFeedPagination extends Vue {
  @Prop({ required: true, type: Number })
  readonly page!: number;

  @Prop({ required: true, type: Number })
  readonly pageSize!: number;

  @Prop({ required: true, type: Number })
  readonly totalItems!: number;

  get totalPages(): number {
    return getSocialFeedTotalPages(this.totalItems, this.pageSize);
  }

  get showPagination(): boolean {
    return this.totalItems > this.pageSize;
  }

  get rangeStart(): number {
    if (!this.totalItems) {
      return 0;
    }
    return (this.page - 1) * this.pageSize + 1;
  }

  get rangeEnd(): number {
    return Math.min(this.page * this.pageSize, this.totalItems);
  }
}
